import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/material/form-field';
var ButtonTypeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ButtonTypeComponent, _super);
    /**
     * Class constructor
     */
    function ButtonTypeComponent() {
        return _super.call(this) || this;
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    ButtonTypeComponent.prototype.ngOnInit = function () {
    };
    ButtonTypeComponent.prototype.onClick = function ($event) {
        if (this.to.onClick) {
            this.to.onClick($event);
        }
    };
    return ButtonTypeComponent;
}(FieldType));
export { ButtonTypeComponent };
